import { render } from "./QuickpayPaymentOverview.vue?vue&type=template&id=f2db8288&scoped=true"
import script from "./QuickpayPaymentOverview.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentOverview.vue?vue&type=script&lang=js"

import "./QuickpayPaymentOverview.vue?vue&type=style&index=0&id=f2db8288&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2db8288"]])

export default __exports__